module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.49f251d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.ttf
// module id = 5W8p
// module chunks = 12